module.exports = __webpack_public_path__ + "img/hx_6.328ccf60.jpg";